import {
  ADMIN,
  CUSTOMER,
  DEVELOPER,
  QUALITY_ASSURANCE,
} from "entities/user/role";
import useRole from "hooks/useRole";
import { DefaultPermission } from "utils/permission";

export default function useCancelFlowPermissions(): DefaultPermission {
  const { hasRole, hasNotRole } = useRole();

  return {
    canCreate: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE),
    canEdit: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE),
    canDelete: hasRole(ADMIN, DEVELOPER),
    canList: hasNotRole(CUSTOMER),
    canShow: hasNotRole(CUSTOMER),
  };
}
